"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: function root(props) {
      return {
        width: props.width,
        borderRadius: 2
      };
    },
    content: {
      padding: theme.spacing(2)
    }
  };
};

exports.default = _default;